// Per-location UTM call-number swap.
//
// The server renders the real dealer numbers (fully cacheable) and ships a
// cache-safe config in AP_DATA.callSwap: one entry per dealer_location with UTM
// numbers, `{ tel: <default digits>, map: { <utm_source>: <number> } }`. This
// reads the visitor's utm_source (from the URL, or the attribution last-touch
// cookie so it persists as they browse) and swaps every matching `tel:` link's
// href AND its visible number to that source's number — client-side, so it never
// pollutes the page cache. No match / no source / JS off → the default stays.

function normTel(v) {
  return String(v == null ? '' : v).replace(/[^+\d]/g, '');
}

// The visitor's utm_source: prefer the current URL, fall back to the first-party
// `atpl_attr_last` cookie the attribution layer maintains (shape: { s, m, c, … }).
function currentUtmSource() {
  try {
    const u = new URLSearchParams(window.location.search).get('utm_source');
    if (u && u.trim()) return u.trim().toLowerCase();
  } catch (e) { /* noop */ }
  try {
    const m = document.cookie.match(/(?:^|;\s*)atpl_attr_last=([^;]+)/);
    if (m) {
      const o = JSON.parse(decodeURIComponent(m[1]));
      if (o && o.s) return String(o.s).trim().toLowerCase();
    }
  } catch (e) { /* noop */ }
  return '';
}

export function initCallSwap() {
  const cfg = (typeof window !== 'undefined' && window.AP_DATA && Array.isArray(window.AP_DATA.callSwap))
    ? window.AP_DATA.callSwap : [];
  if (!cfg.length) return;

  const source = currentUtmSource();
  if (!source) return;

  // default-tel digits → replacement number (formatted) for THIS source.
  const repl = new Map();
  cfg.forEach((e) => {
    const num = e && e.map ? e.map[source] : '';
    if (e && e.tel && num) repl.set(normTel(e.tel), num);
  });
  if (!repl.size) return;

  const swapAll = () => {
    document.querySelectorAll('a[href^="tel:"]').forEach((a) => {
      if (a.dataset.callswapped) return;
      const cur = normTel(a.getAttribute('href').slice(4));
      const num = repl.get(cur);
      if (!num) return;
      a.setAttribute('href', 'tel:' + normTel(num));
      a.dataset.callswapped = '1';
      // Swap any visible number inside the link (a text node whose digits match
      // the old number) to the new one, preserving surrounding markup.
      const walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null);
      const hits = [];
      while (walker.nextNode()) {
        if (normTel(walker.currentNode.nodeValue) === cur) hits.push(walker.currentNode);
      }
      hits.forEach((t) => { t.nodeValue = t.nodeValue.replace(/[+\d][\d\s().-]*\d/, num); });
    });
  };

  swapAll();

  // Some tel: links are injected later (catalog cards, opened modals). Re-run on
  // DOM additions, debounced; the per-link `callswapped` guard prevents rework.
  let scheduled = false;
  const mo = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; swapAll(); });
  });
  mo.observe(document.body, { childList: true, subtree: true });
}
